import type { RouteLocationNormalizedLoaded } from 'vue-router'

export const getProductFromRoute = ({ params, query }: RouteLocationNormalizedLoaded) => {
  const gameId = useHighFrequencyGamesOfLicensedTerritory().getHighFrequencyGameIdInCorrectCase(
    String(params?.gameId || query?.p),
  )
  if (gameId) return gameId.toLowerCase()

  const lotteryId = getLotteryIdInCorrectCase(String(params?.lotteryId || query?.p))
  if (lotteryId) return lotteryId.toLowerCase()

  let fallbackId = params?.slug || query?.p
  if (Array.isArray(fallbackId)) fallbackId = fallbackId[0]

  return fallbackId ? String(fallbackId).toLowerCase() : null
}
